import React from "react";
import { Container, Image } from "react-bootstrap";
// import Slider from "react-slick";
// import { useTranslation } from "react-i18next";

const Banner = () => {
  const lang = window.localStorage.getItem("i18nextLng");

  return (
    <Container fluid>
      {lang === "en" ? (
        <Image
          src="vasthubanneren.png"
          class="img-fluid"
          object="fill"
          alt="mainPic"
          width="100%"
          height="100%"
        />
      ) : lang === "ta" ? (
        <Image
          src="bannertamil.png"
          class="img-fluid"
          object="fill"
          alt="mainPic"
          width="100%"
          height="100%"
        />
      ) : (
        <Image
          src="vasthubannerhi.png"
          class="img-fluid"
          object="fill"
          alt="mainPic"
          width="100%"
          height="100%"
        />
      )}
    </Container>
  );
};
export default Banner;
